import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createNews, getNews, updateNews } from 'redux/actions/NewsManager';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import AppSelectBox from '@jumbo/components/Common/formElements/AppSelectBox';
import useStyles from './Editor.style';

import { Avatar, Card, Checkbox, Chip, FormControlLabel, ListItemText, MenuItem, TextField } from '@material-ui/core';
import { findProfessions, getMovieList, resetMovieInfiteList, setFilterType } from 'redux/actions/Movies';
import CmtAvatar from '@coremat/CmtAvatar';
import { Autocomplete } from '@material-ui/lab';
import useDebounce from '@jumbo/utils/hooks/useDebounce/useDebounce';

import { ContentState, convertFromHTML, EditorState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from 'react-draft-wysiwyg';

import _ from 'lodash';
import draftToHtml from 'draftjs-to-html';
import UploadNewsPosterDropZone from './UploadPoster/UploadNewsPosterDropZone';
import CmtImage from '@coremat/CmtImage';

const IS_DROPDOWN = true;

const importantOtions = [
  { important: 'رپورتاژ متفرقه', importantId: 'otherReportazh' },
  { important: 'رپورتاژ سینمایی', importantId: 'cinemaReportazh' },
  { important: 'معمولی', importantId: 'ordinary' },
  { important: 'مهم', importantId: 'important' },
  { important: 'تیتر اول', importantId: 'topNews' },
];

const newsTypeOptions = [
  { newsType: 'روزانه ایرانی', newsTypeId: 'daily_iran' },
  { newsType: 'روزانه خارجی', newsTypeId: 'daily_foreign' },
  { newsType: 'اطلاعات فیلم', newsTypeId: 'movie_info' },
  { newsType: 'گزارش تصویری', newsTypeId: 'photo_report' },
  { newsType: 'جشنواره', newsTypeId: 'festival' },
  { newsType: 'جشنواره تصویری', newsTypeId: 'festival_photo_report' },
];

const stateOptions = [
  { state: 'انتشار', stateId: 'undefined' },
  { state: 'Draft', stateId: 'draft' },
];

const NewsManagement = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const newsId = params.get('news');

  const { currentNews, newsPosterProps } = useSelector(({ news }) => news);
  const { professionProfile, movieInfiniteList, filterType, metaMovieInfiniteList } = useSelector(({ movies }) => movies);

  const [title, setTitle] = useState('');
  const [urlTitle, setUrlTitle] = useState('');
  const [h1Tag, setH1Tag] = useState('');
  const [abstract, setAbstract] = useState('');
  const [state, setState] = useState('');
  const [important, setImportant] = useState('');
  const [newsType, setNewsType] = useState('');
  const [verified, setVerified] = useState(false);
  const [traslated, setTraslated] = useState(false);
  const [resource, setResource] = useState('');
  const [tags, setTags] = useState([]);
  const [users, setUsers] = useState([]);
  const [movies, setMovies] = useState([]);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  const [uploadLoading, setUploadLoading] = useState(false);

  const [movieName, setMovieName] = useState('');
  const [tagOptions, setTagOptions] = useState([]);

  const debouncedSeriesName = useDebounce(movieName, 500);

  useEffect(() => {
    dispatch(getMovieList({ ...filterType, page: 1, per_page: 30, sorted: { column: 'submited_time', direction: 'asc' } }, IS_DROPDOWN));
    dispatch(resetMovieInfiteList())
    setHasMore(true)
  }, [filterType, dispatch]);

  useEffect(() => {
    dispatch(setFilterType({ by_name: debouncedSeriesName }));
  }, [debouncedSeriesName, dispatch]);

  React.useEffect(() => {
    if (currentNews?.id) {
      const htmlContent = currentNews.news;

      // Convert HTML content to EditorState
      const blocksFromHTML = convertFromHTML(htmlContent);
      const contentState = ContentState.createFromBlockArray(blocksFromHTML);

      setTitle(currentNews.title || '');
      setH1Tag(currentNews.h1_tag || '');
      setUrlTitle(currentNews.url_title || '');
      setAbstract(currentNews.abstract || '');
      setImportant(currentNews.important || '');
      setNewsType(currentNews.news_type || '');
      setVerified(currentNews.verified || false);
      setTraslated(currentNews.traslated || false);
      setResource(currentNews.resource || '');
      setTagOptions(currentNews.tags || []);
      setTags(currentNews.tags || '');
      setUsers(currentNews.assign_users || '');
      setMovies(currentNews.assign_movies || '');
      setState(currentNews.state || '');
      setEditorState(EditorState.createWithContent(contentState));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [currentNews]);

  const handleSearchProfessions = name => {
    dispatch(findProfessions(name));
  };

  useEffect(() => {
    if (newsId) {
      dispatch(getNews(newsId));
    }
  }, [dispatch, newsId])

  const uploadImageCallBack = () => {

  }

  const handleSubmit = () => {
    setUploadLoading(true);

    const content = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    const formData = new FormData();
    formData.append('poster', newsPosterProps);
    formData.append('title', title);
    formData.append('url_title', urlTitle);
    formData.append('h1_tag', h1Tag);
    formData.append('abstract', abstract);
    formData.append('state', state);
    formData.append('important', important);
    formData.append('verified', verified);
    formData.append('traslated', traslated);
    formData.append('resource', resource);
    tags.forEach(tag => {
      formData.append('tags[]', tag.name ?? tag);
    });
    users.forEach(user => {
      formData.append('user_ids[]', user.id);
    });
    movies.forEach(movie => {
      formData.append('movie_ids[]', movie.id);
    });
    formData.append('news_type', newsType);
    formData.append('news', content.toString());


    if (currentNews?.id) {
      dispatch(updateNews(currentNews?.id, formData, setUploadLoading));
    } else {
      dispatch(createNews(formData, setUploadLoading))
    }
  };

  const loadOptions = () => {
    if (loading || !hasMore) return;

    setLoading(true);

    try {
      const nextPageFilter = { ...filterType, page: filterType.page + 1 };
      dispatch(getMovieList({
        ...nextPageFilter,
        per_page: 30,
        sorted: { column: 'submited_time', direction: 'asc' }
      }, true));

      const moreOptionsAvailable = metaMovieInfiniteList?.total_pages > filterType.page + 1 ? true : false;
      setHasMore(moreOptionsAvailable);
    } catch (error) {
      console.error('Error loading options:', error);
    }

    setLoading(false);
  };

  const handleScroll = (event) => {
    const target = event.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      loadOptions();
    }
  };

  const handleTagInputChange = (event, newValue) => {
    // Adding the new tag to options if it doesn't already exist
    const newTags = newValue.trim().split(/\s+/).filter(tag => tag !== '');
    setTagOptions(newTags);
  };

  return (
    <React.Fragment>
      <GridContainer>
        <Grid item xs={12} sm={6}>
          <CmtImage src={currentNews?.posters?.large || "https://placehold.co/1000x867/png"} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card className={classes.cardRoot}>
            <UploadNewsPosterDropZone />
            <AppTextInput
              fullWidth
              type="text"
              variant="outlined"
              value={newsPosterProps?.name}
              style={{ marginTop: 20 }}
              disabled
            />
          </Card>
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="تیتر"
            value={title}
            onChange={e => {
              setTitle(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="منبع خبر"
            value={resource}
            onChange={e => {
              setResource(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="تگ هدر"
            value={h1Tag}
            onChange={e => {
              setH1Tag(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="URL تیتر"
            value={urlTitle}
            onChange={e => {
              setUrlTitle(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={newsTypeOptions}
            label="نوع خبر"
            value={newsType}
            onChange={e => setNewsType(e.target.value)}
            valueKey="newsTypeId"
            variant="outlined"
            labelKey="newsType"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={importantOtions}
            label="اولویت"
            value={important}
            onChange={e => setImportant(e.target.value)}
            valueKey="importantId"
            variant="outlined"
            labelKey="important"
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            multiple
            options={tagOptions}
            id="tags"
            value={tags}
            getOptionLabel={option => option?.name || option}
            onChange={(e, value) => setTags(value)}
            onInputChange={handleTagInputChange}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="تگ‌ها"
                placeholder="تگ‌ها"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={stateOptions}
            label="وضعیت"
            value={state}
            onChange={e => setState(e.target.value)}
            valueKey="stateId"
            variant="outlined"
            labelKey="state"
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            id="actors-autocomplete"
            options={professionProfile}
            getOptionLabel={option => option.fullname ? option.fullname : option.user.fullname}
            value={users}
            onChange={(event, newValue) => {
              setUsers(newValue);
            }}
            onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="انتخاب بازیگران"
                placeholder="بازیگران"
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={index}
                  avatar={<Avatar alt={option.fullname ? option.fullname : option.user.fullname} src={option?.user_img ? option?.user_img : option?.user?.user_img} />}
                  label={option.fullname ? option.fullname : option.user.fullname}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderOption={(props, option) => {
              return (
                <MenuItem {...props}>
                  <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                  <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                </MenuItem>
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            multiple
            fullWidth
            id="combo-box-movie-id"
            options={movieInfiniteList}
            disableCloseOnSelect
            value={movies}
            loading={loading}
            getOptionSelected={(option, value) => _.isEqual(option, value)}
            onChange={(event, value) => setMovies(value)}
            onInputChange={(event, newInputValue) => setMovieName(newInputValue)}
            getOptionLabel={option => option?.name || ''}
            renderInput={params => <TextField {...params} label="نام فیلم یا سریال" variant="outlined" />}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={index}
                  avatar={<Avatar alt={option?.name} src={option?.posters?.small} />}
                  label={option?.name}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderOption={(props, option) => {
              return (
                <MenuItem {...props}>
                  <CmtAvatar size={40} src={props?.posters?.small} alt={props.name} variant="rounded" />
                  <ListItemText primary={props.name} style={{ marginRight: 7 }} />
                </MenuItem>
              );
            }}
            PopperComponent={(props) => <div {...props} onScroll={handleScroll} />}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 10 }}>
        <Grid item xs={6} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={verified}
                inputProps={{ 'aria-label': 'controlled' }}
                onChange={event => setVerified(event.target.checked)}
              />
            }
            label="تایید شده"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={traslated}
                inputProps={{ 'aria-label': 'controlled' }}
                onChange={event => setTraslated(event.target.checked)}
              />
            }
            label="ترجمه شده"
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12}>
          <AppTextInput
            multiline
            minRows={6}
            fullWidth
            variant="outlined"
            label="چکیده"
            value={abstract}
            onChange={e => {
              setAbstract(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12, marginTop: 12 }}>
        <Grid item xs={12} sm={12} className={classes.editorRoot}>
          <Editor
            editorStyle={{
              width: '100%',
              minHeight: 100,
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: 'lightgray',
              padding: 20,
            }}
            toolbar={{
              options: [
                'inline',
                'blockType',
                'fontSize',
                'fontFamily',
                'image',
                'embedded',
                'emoji',
                'link',
                'list',
                'textAlign',
                'colorPicker',
                'remove',
                'history',
              ],
              image: {
                uploadCallback: uploadImageCallBack,
                urlEnabled: true,
                uploadEnabled: true,
                previewImage: true,
                alignmentEnabled: true,
                alt: { present: true, mandatory: true },
              },
              fontFamily: {
                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
              },
              list: {
                inDropdown: false,
                options: ['unordered', 'ordered', 'indent', 'outdent'],
              },
            }}
            editorState={editorState}
            onEditorStateChange={editorState => setEditorState(editorState)}
          />
        </Grid>
      </GridContainer>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={() => history.push('/news')}>{'بازگشت'}</Button>
        <Box ml={2}>
          <Button disabled={uploadLoading} variant="contained" color="primary" onClick={handleSubmit}>
            {uploadLoading ? "درحال ثبت..." : currentNews?.id ? "بروزرسانی خبر" : "ثبت خبر"}
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default NewsManagement;
